import ApiHelper from 'helpers/creditApiHelper';
import { LOGOUT_URL } from 'helpers/diligence/authHelper';

export const logout = async () => {
    return ApiHelper.doRequest(`${LOGOUT_URL}`, 'post')
        .then(result => {
            return result;
        });
};